function initSplitTextAnimations() {
  if (!gsap || !ScrollTrigger || !SplitText) return;
  gsap.registerPlugin(SplitText, ScrollTrigger);

  const containers = document.querySelectorAll('[data-split-on]');

  containers.forEach((container) => {

    if (container.dataset.splitInitialized) return;
    container.dataset.splitInitialized = true;

    const heading = container.querySelector('.rich-text__heading');
    if (!heading) return;

    const split = new SplitText(heading, { types: 'words, chars', tagName: 'span' });
    gsap.set(split.chars, { color: 'inherit' });
    gsap.to(split.chars, {
      color: 'rgb(var(--color-foreground))',
      ease: 'power1.out',
      duration: 0.5,
      stagger: 0.015,
      scrollTrigger: {
        trigger: container,
        start: 'top 100%',
        end: 'bottom 80%',
        scrub: true, 
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initSplitTextAnimations);
document.addEventListener('shopify:section:load', initSplitTextAnimations);

document.addEventListener('shopify:section:unload', (event) => {
  const containers = event.target.querySelectorAll('[data-split-on]');
  containers.forEach((container) => {
    container.dataset.splitInitialized = false;
  });
  ScrollTrigger.getAll().forEach((st) => st.kill());
});
